import apiClient from "./config";
import MORTGAGE_SCENARIO_ENDPOINTS from "./endpoints/mortgageScenarioEndpoints";

const mortgageScenarioService = {
  list: () => apiClient.get(MORTGAGE_SCENARIO_ENDPOINTS.LIST),
  create: (data) => apiClient.post(MORTGAGE_SCENARIO_ENDPOINTS.CREATE, data),
  update: (id, data) =>
    apiClient.put(MORTGAGE_SCENARIO_ENDPOINTS.UPDATE(id), data),
  remove: (id) => apiClient.delete(MORTGAGE_SCENARIO_ENDPOINTS.REMOVE(id)),
  touchView: (id) => apiClient.patch(MORTGAGE_SCENARIO_ENDPOINTS.VIEW(id)),
};

export default mortgageScenarioService;
